module.exports = __webpack_public_path__ + "img/3.843a5ff7.jpg";